import { render, staticRenderFns } from "./wastetype.vue?vue&type=template&id=82a4e102&"
import script from "./wastetype.vue?vue&type=script&lang=ts&"
export * from "./wastetype.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "wastetype.vue"
export default component.exports